export const wait = (ms: number) =>
  new Promise((resolve) => setTimeout(() => resolve(''), ms));

export const isTouchDevice = () => {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-expect-error
    navigator.msMaxTouchPoints > 0
  );
};
